import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { Grid, IconButton, Tooltip } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import {Button,CollapsibleSection,MuiTable,StatusChip,TextValidator,ValidatorForm,ConfirmDialog,TableTopSearch,SingleViewDialog,} from "components";
import {BranchDropDown,DepartmentDropDown,DesignationDropDown,OfficerTypeDropDown,} from "AutoComplites";
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import VisibilityIcon from "@mui/icons-material/VisibilityOutlined";
import { scrollToTop } from "Utils";
import localStorageService from "services/localStorageService";
import EmployeesServices from "services/EmployeesServices";
import EmployeeBranchesServices from "services/EmployeeBranchesServices";
import {
  bureau_officer_types,
  ccid_officer_types,
  mowca_officer_types,
  ncpa_officer_types,
  officer_types,
  slcert_officer_types,
} from "../../../appConst";

const initial_form = {
  organization: null,
  admin_name: null,
  email: null,
  phone: null,
  nic: null,
  designation: null,
  status: "Active",
  userId: null,
  officerType: "",
  "order[0]": ["updatedAt", "DESC"],
};

const AddOGrgSetupOfficers = ({ org }) => {
  const [formData, setFormData] = useState(initial_form);
  const [officerType, setOfficerType] = React.useState(null);
  const [branch, setBranch] = useState(null);
  const [department, setDepartment] = useState(null);
  const columns = [
    { accessorKey: "branch", header: "Branch" },
    { accessorKey: "department", header: "Department" },
    {
      accessorKey: "action",
      header: "Action",
      Cell: ({ row }) => (
        <div style={{ display: "flex", gap: 8 }}>
          <Tooltip title="Edit">
            <IconButton
              size="small"
              color="primary"
              onClick={() => handleEditBranchDept(row.index)}
              disabled={editingBranchDeptIndex !== null && editingBranchDeptIndex !== row.index}
            >
              <DriveFileRenameOutlineOutlinedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              size="small"
              color="error"
              onClick={() => handleDeleteBranchDept(row.index)}
              disabled={editingBranchDeptIndex !== null}
            >
              <DeleteOutlineOutlinedIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const [branchDeptData, setBranchDeptData] = useState([]);
  const [editingBranchDeptIndex, setEditingBranchDeptIndex] = useState(null);
  const [tempEditBranch, setTempEditBranch] = useState(null);
  const [tempEditDepartment, setTempEditDepartment] = useState(null);
  const [originalBranchDeptData, setOriginalBranchDeptData] = useState([]);
  const handleDeleteBranchDept = (index) => {
    setBranchDeptData((prev) => prev.filter((_, i) => i !== index));

    if (editingBranchDeptIndex === index) {
      setEditingBranchDeptIndex(null);
      setTempEditBranch(null);
      setTempEditDepartment(null);
    }

    if (editingBranchDeptIndex !== null && editingBranchDeptIndex > index) {
      setEditingBranchDeptIndex(editingBranchDeptIndex - 1);
    }
  };


  const handleEditBranchDept = (index) => {
    const item = branchDeptData[index];
    setEditingBranchDeptIndex(index);
    setTempEditBranch({ id: item.branch_id, name: item.branch });
    setTempEditDepartment({ id: item.department_id, name: item.department });
  };

  
  const handleUpdateBranchDept = (index) => {
    if (!tempEditBranch || !tempEditDepartment) {
      toast.error('Please select both branch and department');
      return;
    }

    const duplicateExists = branchDeptData.some(
      (item, i) => i !== index && item.branch_id === tempEditBranch.id
    );

    if (duplicateExists) {
      toast.error('This branch already exists in the list!');
      return;
    }

    setBranchDeptData((prev) => 
      prev.map((item, i) => 
        i === index 
          ? {
              branch: tempEditBranch.name || tempEditBranch,
              department: tempEditDepartment.name || tempEditDepartment,
              branch_id: tempEditBranch.id || tempEditBranch,
              department_id: tempEditDepartment.id || tempEditDepartment,
            }
          : item
      )
    );

 
    setEditingBranchDeptIndex(null);
    setTempEditBranch(null);
    setTempEditDepartment(null);
    toast.success('Updated list added successfully!');
  };

 
  const handleCancelEdit = () => {
    setEditingBranchDeptIndex(null);
    setTempEditBranch(null);
    setTempEditDepartment(null);
  };

 
  const handleAddBranchDept = () => {
    if (branch && department) {
      setBranchDeptData((prev) => [
        ...prev,
        {
          branch: branch.name || branch,
          department: department.name || department,
          branch_id: branch.id || branch,
          department_id: department.id || department,
        },
      ]);
      setBranch(null);
      setDepartment(null);
    }
  };

  const updateAdminStatus = async (id, status) => {
  
    const user = await localStorageService.getItem("user");
    if (user && user.id === id) {
      toast.error("Cannot change status of the currently logged-in user.");
      return;
    }
    setLoading(true);
    try {
      const updatedStatus = status === "Active" ? "Inactive" : "Active";
      const response = await EmployeesServices.updateStatus(id, {
        status: updatedStatus,
      });
      if (response && response.success) {
        toast.success(`Status changed to ${updatedStatus}`);
        getData();
      } else {
        toast.error(response?.message || "Failed to update status.");
      }
    } catch (error) {
      console.error("Status update error:", error);
      toast.error(`An unexpected error occurred: ${error?.message || error}`);
    } finally {
      setLoading(false);
      getData();
    }
  };

  const handleChangeStatus = async (id, status) => {
    const actionText = status === "Active"
      ? "deactivate this officer"
      : "activate this officer";
    ConfirmDialog({
      type: status === "Active" ? "error" : "success",
      title: `Are you sure you want to ${actionText}?`,
      description:
        status === "Active"
          ? "This will deactivate the officer. You can reactivate it later."
          : "This will activate the officer. You can deactivate it later.",
      buttons: [
        {
          label: "No",
          onClick: () => toast.info("Action cancelled."),
        },
        {
          label: "Yes",
          onClick: async () => {
            await updateAdminStatus(id, status);
          },
        },
      ],
    });
  };
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editingData, setEditingData] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [filters, setFilters] = useState({
    page: 0,
    limit: 10,
    "order[0]": ["updatedAt", "DESC"],
    search: null,
    officerType: "",
  });
  const [totalItems, setTotalItems] = useState(0);
  
  const [openDialog, setOpenDialog] = useState(false);
  const [singleData, setSingleData] = useState(null);
  const [loginUserOfficerTypes, setLoginUserOfficerTypes] = useState(officer_types);

  const getOfficerTypesByOrganization = useCallback((organizationDetails) => {
    const normalizeText = (value) =>
      (value || "")
        .toString()
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");

    const orgId = (organizationDetails?.id || "").toString().trim().toLowerCase();
    const shortNameNormalized = normalizeText(organizationDetails?.short_name);
    const nameNormalized = normalizeText(organizationDetails?.name);

    const organizationRules = [
      {
        ids: ["9e37dc86-ba59-4316-97a5-8480f6564b59"],
        aliases: ["NCPA", "NATIONALCHILDPROTECTIONAUTHORITY"],
        officerList: ncpa_officer_types,
      },
      {
        ids: ["92683e12-edab-4983-bf13-8045064a5c27"],
        aliases: ["CCID", "COMPUTERCRIMEINVESTIGATIONDIVISIONCYBERCRIME"],
        officerList: ccid_officer_types,
      },
      {
        ids: ["f1c1b3eb-126a-40ff-9434-7e81f8d1df78"],
        aliases: ["SLCERT", "SRILANKACOMPUTEREMERGENCYREADINESSTEAM"],
        officerList: slcert_officer_types,
      },
      {
        ids: ["21bbb7ae-d9b5-4314-b7a2-4a7f32138dd2"],
        aliases: ["BUREAU", "BUREAUFORTHEINVESTIGATIONOFABUSEOFCHILDRENWOMEN"],
        officerList: bureau_officer_types,
      },
      {
        ids: ["747235ea-f8a7-44fa-912f-73881070327a"],
        aliases: ["MOWCA", "MINISTRYOFWOMENANDCHILDAFFAIRS"],
        officerList: mowca_officer_types,
      },
    ];

    const matchedRule = organizationRules.find((rule) =>
      rule.ids.includes(orgId) ||
      rule.aliases.includes(shortNameNormalized) ||
      rule.aliases.includes(nameNormalized)
    );

    return matchedRule?.officerList || officer_types;
  }, []);

  useEffect(() => {
    const loadOfficerTypesFromLoginUser = async () => {
      try {
        const user = await localStorageService.getItem("user");
        const organizationDetails = user?.employee?.organizationDetails;
        setLoginUserOfficerTypes(getOfficerTypesByOrganization(organizationDetails));
      } catch (error) {
        console.error("Failed to load login user organization:", error);
        setLoginUserOfficerTypes(officer_types);
      }
    };

    loadOfficerTypesFromLoginUser();
  }, [getOfficerTypesByOrganization]);

  const getData = useCallback(async () => {
    setLoading(true);
    try {
      const queryParams = {
        page: filters.page,
        limit: filters.limit,
        "order[0]": filters["order[0]"],
        organization_id: org?.id,
      };
      if (filters.search) {
        queryParams.search = filters.search;
      }
      if (filters.designation_id) {
        queryParams.designation_id = filters.designation_id;
      }
      if (filters.branch_id) {
        queryParams.branch_id = filters.branch_id;
      }
      if (filters.department_id) {
        queryParams.department_id = filters.department_id;
      }
      if (filters.officerType) {
        queryParams.type = filters.officerType;
      }

      const response = await EmployeesServices.get(queryParams);
      if (response.success) {
        const responseData = response?.data?.view?.data || response?.data || [];
        setData(responseData);
        setTotalItems(response?.data?.view?.totalItems || responseData.length);
      }
    } catch (error) {
      toast.error("Failed to fetch data. Please try again.");
      setData([]);
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
  }, [filters, org]);

  useEffect(() => {
    getData();
  }, [getData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const setPage = (page) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      page: page - 1,
    }));
  };

  const setPageSize = (pageSize) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      page: 0,
      limit: pageSize,
    }));
  };

  const handleView = async (id) => {
    const selectedRow = data.find((item) => item.id === id);
    if (selectedRow) {
      setSingleData(selectedRow);
      try {
        const response = await EmployeeBranchesServices.get({
          employee_id: id,
        });
        if (response.status === 200) {
          const branchDeptList = response?.data?.data || [];
          selectedRow.branchDeptAssignments = branchDeptList;
        }
      } catch (error) {
        console.error('Error loading branch/dept data for view:', error);
        selectedRow.branchDeptAssignments = [];
      }
      
      setSingleData(selectedRow);
      setOpenDialog(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      if (!formData.designation) {
        toast.error("Designation is required!");
        setSubmitting(false);
        return;
      }
      const emailToCheck = formData.email?.trim().toLowerCase();
      const emailExists = data.some(
        (item) =>
          item.email &&
          item.email.trim().toLowerCase() === emailToCheck &&
          (!isEdit || item.id !== editingData)
      );
      if (emailExists) {
        toast.error("This email already exists. Please use a different email.");
        setSubmitting(false);
        return;
      }

      const apiData = Object.fromEntries(
        Object.entries(formData).filter(
          ([_, value]) => value !== null && value !== ""
        )
      );

      let user = await localStorageService.getItem("user");
      apiData.userId = user.id;
      apiData.type = officerType || "";
      if (!apiData.status) {
        apiData.status = "Active";
      }

      if (isEdit && editingData === user.id && apiData.type !== (formData.officerType || formData.type)) {
        toast.error("Cannot change officer type of the currently logged-in user.");
        setSubmitting(false);
        return;
      }

      if (apiData.admin_name) {
        apiData.name = apiData.admin_name;
        delete apiData.admin_name;
      }

      if (apiData.phone) {
        apiData.contact_no = apiData.phone;
        delete apiData.phone;
      }

      apiData.organization_id = org?.id;
      delete apiData.organization;

      if (apiData.designation) {
        apiData.designation_id = apiData.designation;
        delete apiData.designation;
      }

      let response;
      if (isEdit) {
        response = await EmployeesServices.update(editingData, apiData);
        if (response.success) {
          toast.success("Updated successfully!");
          try {
            const itemsToDelete = originalBranchDeptData.filter(original => 
              !branchDeptData.some(current => current.id === original.id)
            ); 
            const itemsToAdd = branchDeptData.filter(current => !current.id);
            
       
            const itemsToUpdate = branchDeptData.filter(current => {
              if (!current.id) return false; 
              const original = originalBranchDeptData.find(orig => orig.id === current.id);
              return original && (
                original.branch_id !== current.branch_id || 
                original.department_id !== current.department_id
              );
            });
            
          
            await Promise.all(
              itemsToDelete.map(item => 
                EmployeeBranchesServices.delete(item.id)
              )
            );

            await Promise.all(
              itemsToAdd.map(item =>
                EmployeeBranchesServices.create({
                  employee_id: editingData,
                  branch_id: item.branch_id,
                  department_id: item.department_id,
                })
              )
            );
            
            await Promise.all(
              itemsToUpdate.map(item =>
                EmployeeBranchesServices.updatepatch(item.id, {
                  branch_id: item.branch_id,
                  department_id: item.department_id,
                  employee_id: editingData,
                })
              )
            );
            
            console.log('Branch/Department assignments updated successfully');
          } catch (error) {
            console.error('Error updating branch/department assignments:', error);
            toast.error('Officer updated but there was an issue with branch/department assignments');
          }
        } else {
          toast.error("Failed to update. Please try again.");
        }
      } else {
        response = await EmployeesServices.create(apiData);
        console.log("read", response);

        if (response.success) {
          toast.success("Created successfully!");

          if (response.status === 201) {
            if (!isEdit && branchDeptData.length > 0) {
              try {
                await Promise.all(
                  branchDeptData.map(({ branch_id, department_id }) =>
                    EmployeeBranchesServices.create({
                      employee_id: response.data?.posted.data.id,
                      branch_id,
                      department_id,
                    })
                  )
                );
                console.log("All branches assigned successfully");
              } catch (err) {
                console.error("Error assigning branches:", err);
              }
            }
          }
        } else {
          toast.error("Failed to create. Please try again.");
        }
      }

      if (response.success) {
        setFormData(initial_form);
        setIsEdit(false);
        setOpenEditModal(false);
        setEditingData(null);
        setBranchDeptData([]);
        setBranch(null);
        setDepartment(null);
        setOfficerType(null);
        setEditingBranchDeptIndex(null);
        setTempEditBranch(null);
        setTempEditDepartment(null);
        setOriginalBranchDeptData([]);
        getData();
        scrollToTop();
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
        <CollapsibleSection
          title="Add Officers"
          collapsTrigger={openEditModal}
          buttonText="Add new Officers"
        >
          <ValidatorForm onSubmit={handleSubmit} process={submitting}>
            <Grid container spacing={1}>
              <Grid size={{ lg: 4, md: 4, sm: 6, xs: 12 }}>
                <TextValidator
                  label="Officer Name"
                  name="admin_name"
                  value={formData.admin_name || ""}
                  onChange={handleInputChange}
                  validators={["required"]}
                  errorMessages={["This field is required"]}
                  required={true}
                  disabled={loading}
                  placeholder="Enter Officer name"
                />
              </Grid>
              <Grid size={{ lg: 4, md: 4, sm: 6, xs: 12 }}>
                <TextValidator
                  label="Phone"
                  name="phone"
                  type="tel"
                  value={formData.phone || ""}
                  onChange={handleInputChange}
                  validators={[
                    "required",
                    "matchRegexp:^\\d+$",
                    "minStringLength:10",
                    "maxStringLength:10",
                  ]}
                  errorMessages={[
                    "This field is required",
                    "Only numbers are allowed",
                    "Minimum length is 10 digits",
                    "Maximum length is 10 digits",
                  ]}
                  required={true}
                  disabled={loading}
                  placeholder="Enter phone number"
                  inputProps={{ maxLength: 10 }}
                />
              </Grid>
              <Grid size={{ lg: 4, md: 4, sm: 6, xs: 12 }}>
                <TextValidator
                  label="Email"
                  name="email"
                  type="email"
                  value={formData.email || ""}
                  onChange={handleInputChange}
                  validators={["required", "isEmail"]}
                  errorMessages={[
                    "This field is required",
                    "Email is not valid",
                  ]}
                  required={true}
                  disabled={loading}
                  placeholder="Enter email address"
                />
              </Grid>

              <Grid size={{ lg: 4, md: 4, sm: 6, xs: 12 }}>
                <DesignationDropDown
                  name="designation"
                  label="Designation"
                  value={formData.designation || ""}
                  onChange={(event, newValue) => {
                    setFormData((prev) => ({
                      ...prev,
                      designation: newValue ? newValue.id : "",
                    }));
                  }}
                  required={true}
                  validators={["required"]}
                  errorMessages={["This field is required"]}
                  disabled={loading}
                  placeholder="Select designation"
                />
              </Grid>
              <Grid size={{ lg: 4, md: 4, sm: 6, xs: 12 }}>
                <OfficerTypeDropDown
                  label="Officer Type"
                  value={officerType}
                  onChange={(e, v) => setOfficerType(v)}
                  officerTypes={loginUserOfficerTypes}
                  required={true}
                  validators={["required"]}
                  placeholder="Select officer type"
                />
              </Grid>

              <Grid size={{ lg: 4, md: 4, sm: 6, xs: 12 }}>
                <TextValidator
                  label="NIC"
                  name="nic"
                  value={formData.nic || ""}
                  onChange={handleInputChange}
                  validators={["required", "matchRegexp:^([0-9]{9}[vVxX]|[0-9]{12})$"]}
                  errorMessages={[
                    "This field is required",
                    "Enter a valid NIC (9 digits + V/X or 12 digits)",
                  ]}
                  required={true}
                  disabled={loading}
                  placeholder="Enter NIC number"
                />
              </Grid>

              <Grid size={{ lg: 8, md: 12, sm: 12, xs: 12 }}>
                <div
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: 8,
                    minHeight: 80,
                    padding: 16,
                  }}
                >
                  <ValidatorForm>
                    <Grid container spacing={1} sx={{ mb: 2 }}>
                      <Grid size={{ lg: 6, md: 6, sm: 6, xs: 12 }}>
                        <BranchDropDown
                          label="Branch"
                          value={editingBranchDeptIndex !== null ? tempEditBranch?.id : branch?.id}
                          onChange={(e, v) => {
                            if (editingBranchDeptIndex !== null) {
                              setTempEditBranch(v);
                            } else {
                              setBranch(v);
                            }
                          }}
                          filter={
                            org?.id ? { organization_id: org.id } : undefined
                          }
                        />
                      </Grid>
                      <Grid size={{ lg: 6, md: 6, sm: 6, xs: 12 }}>
                        <DepartmentDropDown
                          label="Department"
                          value={editingBranchDeptIndex !== null ? tempEditDepartment?.id : department?.id}
                          onChange={(e, v) => {
                            if (editingBranchDeptIndex !== null) {
                              setTempEditDepartment(v);
                            } else {
                              setDepartment(v);
                            }
                          }}
                          filter={
                            org?.id ? { organization_id: org.id } : undefined
                          }
                        />
                      </Grid>
                      <Grid
                        size={{ lg: 6, md: 6, sm: 12, xs: 12 }}
                        sx={{
            
                          justifyContent: "flex-end",
                          gap: 1,
                        }}
                      >
                        {editingBranchDeptIndex !== null ? (
                          <>
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              onClick={() => handleUpdateBranchDept(editingBranchDeptIndex)}
                              sx={{ minWidth: 80, height: 32 }}
                            >
                              Update
                            </Button>
                            <Button
                              className="btn-warning"
                              onClick={handleCancelEdit}
                              sx={{ minWidth: 80, height: 32, ml: 1 }}
                            >
                              Cancel
                            </Button>
                          </>
                        ) : (
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={handleAddBranchDept}
                            sx={{ minWidth: 60, height: 32 }}
                          >
                            SAVE
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                    <MuiTable
                      columns={columns}
                      data={branchDeptData}
                      muiTableBodyProps={{
                        sx: {
                          "& tr": {
                            minHeight: 32,
                            height: 32,
                          },
                          "& td": {
                            py: 0.5,
                          },
                        },
                      }}
                    />
                  </ValidatorForm>
                </div>
              </Grid>
            </Grid>

            <Grid className="mt-2" container spacing={1}>
              <Grid>
                <Button type="submit" process={submitting}>
                  {isEdit ? "UPDATE" : "SAVE"}
                </Button>
              </Grid>
              <Grid>
                {openEditModal && (
                  <Button
                    className="btn-warning"
                    onClick={() => {
                      setFormData(initial_form);
                      setIsEdit(false);
                      setOpenEditModal(false);
                      setEditingData(null);
                      setBranchDeptData([]);
                      setBranch(null);
                      setDepartment(null);
                      setOfficerType(null);
                      setEditingBranchDeptIndex(null);
                      setTempEditBranch(null);
                      setTempEditDepartment(null);
                      setOriginalBranchDeptData([]);
                    }}
                  >
                    Cancel
                  </Button>
                )}
              </Grid>
            </Grid>
          </ValidatorForm>
        </CollapsibleSection>

        <div>
          <ValidatorForm style={{ marginBottom: 24 }}>
            <Grid container spacing={1} alignItems="center">
              <Grid size={{ lg: 2, md: 4, sm: 6, xs: 12 }}>
                <OfficerTypeDropDown
                  label="Officer Type"
                  value={filters.officerType || ""}
                  officerTypes={loginUserOfficerTypes}
                  onChange={(e, v) => {
                    setFilters((prev) => ({
                      ...prev,
                      officerType: v ? v.id || v : "",
                      page: 0,
                    }));
                  }}
                />
              </Grid>
              <Grid size={{ lg: 2, md: 4, sm: 6, xs: 12 }}>
                <DesignationDropDown
                  name="filter_designation"
                  label="Designation"
                  value={filters.designation_id || ""}
                  onChange={(event, newValue) => {
                    setFilters((prevData) => ({
                      ...prevData,
                      designation_id: newValue ? newValue.id : "",
                    }));
                  }}
                  required={false}
                  disabled={loading}
                />
              </Grid>
              <Grid size={{ lg: 2, md: 4, sm: 6, xs: 12 }}>
                <BranchDropDown
                  name="filter_branch"
                  label="Branch"
                  value={filters.branch_id || ""}
                  filter={{ organization_id: org?.id }}
                  onChange={(event, newValue) => {
                    setFilters((prevData) => ({
                      ...prevData,
                      branch_id: newValue ? newValue.id : "",
                    }));
                  }}
                  required={false}
                  disabled={loading}
                />
              </Grid>
              <Grid size={{ lg: 2, md: 4, sm: 6, xs: 12 }}>
                <DepartmentDropDown
                  name="filter_department"
                  label="Department"
                  value={filters.department_id || ""}
                  filter={{ organization_id: org?.id }}
                  onChange={(event, newValue) => {
                    setFilters((prevData) => ({
                      ...prevData,
                      department_id: newValue ? newValue.id : "",
                    }));
                  }}
                  required={false}
                  disabled={loading}
                />
              </Grid>
              <Grid
                size={{ lg: 2, md: 4, sm: 6, xs: 12 }}>
                <Button
                  variant="outlined" color="error"
className=" mt-5"
                  onClick={() => {
                    setFilters((prevFilters) => ({
                      ...prevFilters,
                      designation_id: "",
                      branch_id: "",
                      department_id: "",
                      officerType: "",
                      page: 0,
                      search: "",
                    }));
                  }}
                  sx={{ height: 40, minWidth: 90, boxSizing: "border-box" }}
                >
                  <FilterAltOutlinedIcon sx={{ mr: 1 }} />
                  Clear
                </Button>
              </Grid>
            </Grid>
          </ValidatorForm>
          
          <TableTopSearch
            title='Officers'
            showSearch={true}
            showTotalWithTitle={true}
            rowCount={totalItems}
            onSubmitSearch={null}
            onSearchChange={(e) => {
              setFilters(prevData => ({
                ...prevData,
                search: e.target.value
              }));
            }}
          />

          <MuiTable
            columns={[
              {
                accessorKey: "name",
                header: "Name",
                Cell: ({ row }) => <span>{row.original.name || ""}</span>,
              },
              {
                accessorKey: "organization",
                header: "Organization",
                Cell: ({ row }) => (
                  <span>{row.original.organizationDetails?.name || ""}</span>
                ),
              },
              {
                accessorKey: "designation",
                header: "Designation",
                Cell: ({ row }) => (
                  <span>{row.original.designationDetails?.name || ""}</span>
                ),
              },
              {
                accessorKey: "contact_no",
                header: "Phone",
                Cell: ({ row }) => (
                  <span>
                    {row.original.contact_no || row.original.phone || ""}
                  </span>
                ),
              },
              {
                accessorKey: "email",
                header: "Email",
                Cell: ({ row }) => <span>{row.original.email || ""}</span>,
              },
              {
                accessorKey: "type",
                header: "Type",
                Cell: ({ row }) => <span>{row.original.type || ""}</span>,
              },
              {
                accessorKey: "createdAt",
                header: "Created Date",
                Cell: ({ row }) => (
                  <span>
                    {row.original.createdAt
                      ? new Date(row.original.createdAt).toLocaleDateString()
                      : ""}
                  </span>
                ),
              },
              {
                accessorKey: "createdAtTime",
                header: "Created Time",
                Cell: ({ row }) => (
                  <span>
                    {row.original.createdAt
                      ? new Date(row.original.createdAt).toLocaleTimeString()
                      : ""}
                  </span>
                ),
              },
              {
                accessorKey: "status",
                header: "Status",
                Cell: ({ cell }) => (
                  <div>
                    <StatusChip
                      status={cell.row.original.status}
                      onClick={() => {
                        handleChangeStatus(
                          cell.row.original.id,
                          cell.row.original.status
                        );
                      }}
                    />
                  </div>
                ),
                headerProps: { style: { textAlign: "right" } },
                cellProps: { style: { textAlign: "right" } },
              },
              {
                accessorKey: "actions",
                header: "Actions",
                Cell: ({ cell }) => (
                  <div style={{ display: "flex", gap: 8 }}>
                    <Tooltip title="Edit">
                      <IconButton
                        size="small"
                        color="secondary"
                        onClick={async () => {
                          setIsEdit(false);
                          setOpenEditModal(false);
                          
                          try {
                            const response = await EmployeeBranchesServices.get({
                              employee_id: cell.row.original.id,
                            });
                            if (response.status === 200) {
                              const existingBranchDept = response?.data?.data || [];
                              const formattedData = existingBranchDept.map(item => ({
                                branch: item.branch?.name || "",
                                department: item.department?.name || "",
                                branch_id: item.branch?.id || "",
                                department_id: item.department?.id || "",
                                id: item.id, 
                              }));
                              setBranchDeptData(formattedData);
                              setOriginalBranchDeptData([...formattedData]); 
                            }
                          } catch (error) {
                            console.error('Error loading branch/dept data:', error);
                            setBranchDeptData([]);
                          }
                          
                          setTimeout(() => { 
                            const editData = {
                              ...cell.row.original,
                              admin_name: cell.row.original.name,
                              phone: cell.row.original.contact_no,
                              organization: cell.row.original.organization_id,
                              designation: cell.row.original.designation_id,
                              officerType:
                                cell.row.original.officerType ||
                                cell.row.original.type ||
                                "",
                            };
                            setFormData(editData);
                            setOfficerType(
                              cell.row.original.officerType ||
                                cell.row.original.type ||
                                ""
                            );
                            setIsEdit(true);
                            setOpenEditModal(true);
                            setEditingData(cell.row.original.id);
                            scrollToTop();
                          }, 500);
                        }}
                      >
                        <DriveFileRenameOutlineOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="View Officer">
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() => handleView(cell.row.original.id)}
                      >
                        <VisibilityIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                ),
                headerProps: { style: { textAlign: "right" } },
                cellProps: { style: { textAlign: "right" } },
              },
            ]}
            data={data}
            title="All Employees"
            manualPagination={true}
            rowCount={totalItems}
            currentPage={filters.page}
            pageSize={filters.limit}
            onPageChange={setPage}
            onPageSizeChange={setPageSize}
            loading={loading}
          />
        </div>
        <SingleViewDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          data={{
            title: singleData?.name,
            otherData: [
              {
                label: "Organization",
                value: singleData?.organizationDetails?.name
              },
              {
                label: "Designation",
                value: singleData?.designationDetails?.name
              },
              {
                label: "Phone",
                value: singleData?.contact_no || singleData?.phone
              },
              {
                label: "Email",
                value: singleData?.email
              },
              {
                label: "Officer Type",
                value: singleData?.type
              },
              {
                label: "Status",
                value: singleData?.status
              },
              {
                label: "Created Date",
                value: singleData?.createdAt ? new Date(singleData.createdAt).toLocaleDateString() : ""
              },
              {
                label: "Created Time",
                value: singleData?.createdAt ? new Date(singleData.createdAt).toLocaleTimeString() : ""
              },
              ...(singleData?.branchDeptAssignments?.length > 0 
                ? [
                    {
                      label: "Branches",
                      value: singleData.branchDeptAssignments.map(item => item.branch?.name || 'N/A').join(', ')
                    },
                    {
                      label: "Departments",
                      value: singleData.branchDeptAssignments.map(item => item.department?.name || 'N/A').join(', ')
                    }
                  ]
                : [
                    {
                      label: "Branch & Department",
                      value: "No assignments"
                    }
                  ]
              ),
            ]
          }}
        />
    </div>
  );
};

export default AddOGrgSetupOfficers;
